import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div className="footer-column">
            <h3 className="text-xl font-bold text-white mb-4">Cleophas Network</h3>
            <p className="text-gray-400 mb-4">Building meaningful professional connections that transform careers and create opportunities.</p>
            <div className="social-links flex space-x-4">
              <a href="https://x.com/Im_Cleophas?t=2dpmwAtajEHC9HlYN2Bzzw&s=09" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors">
                <i className="fab fa-twitter text-white"></i>
              </a>
              <a href="https://www.linkedin.com/in/cleophas-koech-004283284?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors">
                <i className="fab fa-linkedin-in text-white"></i>
              </a>
              <a href="https://www.instagram.com/im_cleophas?igsh=MWU2ZTFjMW5wOXAyeg==" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors">
                <i className="fab fa-instagram text-white"></i>
              </a>
              <a href="https://youtube.com/@im_cleophas?si=Gy45iT6yowNLGnBg" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors">
                <i className="fab fa-youtube text-white"></i>
              </a>
            </div>
          </div>
          
          <div className="footer-column">
            <h3 className="text-xl font-bold text-white mb-4">Resources</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors">Networking Guide</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors">VumaQash Tutorials</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors">Templates</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors">Blog</Link></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h3 className="text-xl font-bold text-white mb-4">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors">Careers</Link></li>
              <li><Link to="/privacy" className="text-gray-400 hover:text-white transition-colors">Privacy Policy</Link></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h3 className="text-xl font-bold text-white mb-4">Contact Me</h3>
            <p className="text-gray-400 mb-4">Have questions? Reach out directly via WhatsApp:</p>
            <a href="https://wa.me/254115647545" className="inline-flex items-center bg-green-600 hover:bg-green-700 text-white font-semibold px-5 py-3 rounded-lg transition-colors">
              <i className="fab fa-whatsapp mr-2"></i> WhatsApp Now
            </a>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-500">&copy; 2023 Cleophas Network. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;